import React from 'react';
import PropTypes from 'prop-types';
import SignalLevelsFields from "./SignalLevelsFields";
import IngressCheckSelectFields from "./IngressCheckSelectFields";
import MenuItem from "material-ui/MenuItem";

const SignalLevelsForm = (props) => {
  const {
    signalLevelsStore,
    signalLevelsDetails,
    sections,
    handleTextValueChange,
    handleCheckStateChange,
    dropdownOptions,
    channels,
  } = props;

  const options = dropdownOptions.map((item, index) => {
    return (<MenuItem
      key={`ingress_check_item${index}`}
      value={item.value}
      primaryText={item.label} />);
  });

  return (
    <div>
      {
        Object.keys(sections).map(section => {
          return (
            <div key={"signal-level-section-" + section} className={"wow-fst-signal-levels-section"}>
              <div className={"wow-fst-signal-levels-section-title"}>
                {sections[section].name}
              </div>
              {
                sections[section].values.map(levels => {
                  if (levels.type === "number") {
                    const tapLevelError = signalLevelsDetails ? signalLevelsDetails.getIn([
                      'tap' + levels.value + 'Error'
                    ]) : "";

                    const groundBlockLevelError = signalLevelsDetails ? signalLevelsDetails.getIn([
                      'groundBlock' + levels.value + 'Error'
                    ]) : "";

                    const tapLevelValue = signalLevelsStore ? signalLevelsStore.get(
                      'tap' + levels.value
                    ) : "";

                    const groundLevelValue = signalLevelsStore ? signalLevelsStore.get(
                      'groundBlock' + levels.value) : "";

                    const channelNumber = channels.getIn([levels.channel]) ?
                      channels.getIn([levels.channel]).toString() :
                      "";

                    return (
                      <div key={levels.value} className="wow-fst-signal-levels-form">
                        <SignalLevelsFields
                          name={levels.name}
                          hasChannelNumbers={levels.hasChannelNumbers}
                          tapLevelError={tapLevelError}
                          groundBlockLevelError={groundBlockLevelError}
                          value={levels.value}
                          tapLevelValue={tapLevelValue}
                          groundBlockLevelValue={groundLevelValue}
                          channelNumber={channelNumber}
                          handleValueChange={handleTextValueChange}
                        />
                      </div>
                    );
                  } else {
                    const tapLevelValue = signalLevelsStore ? signalLevelsStore.get(
                      'tap' + levels.value) : "";

                    const groundLevelValue = signalLevelsStore ? signalLevelsStore.get(
                      'groundBlock' + levels.value) : "";

                    return (
                      <div key={levels.value} className="wow-fst-signal-levels-form">
                        <IngressCheckSelectFields
                          handleOnCheck={handleCheckStateChange}
                          name={levels.name}
                          options={options}
                          hasChannelNumbers={levels.hasChannelNumbers}
                          value={levels.value}
                          tapLevelValue={tapLevelValue}
                          groundBlockLevelValue={groundLevelValue}
                          level={levels}
                        />
                      </div>
                    );
                  }
                })
              }
            </div>
          );
        })
      }
    </div>
  );
}


SignalLevelsForm.propTypes = {
  workOrderActions: PropTypes.object,
  orderId: PropTypes.string,
  techId: PropTypes.string
};

export default SignalLevelsForm;




// WEBPACK FOOTER //
// ./src/components/signal-levels/SignalLevelsForm.js